(function() {
  'use strict';
  
  angular
    .module('plugins.bar-chart', ['app.plugins']);
  
})();